import { HELP_URL } from '@palaccount/config';

import { groupForPath } from '@/app/shell/nav';

import type { SectionId } from './help-content';

/**
 * Where the top bar's Help button goes FROM a given screen: the Help page,
 * scrolled to the section for the module the person is standing in. Kept in
 * its own small module so the top bar imports a path function and not the
 * help page's content or components (the page is code-split; this is not).
 *
 * The map is by menu GROUP, which is what `headingForPath` reads too, so the
 * breadcrumb and the Help button agree about where the person is. Groups
 * with no section of their own (Home, HR, Settings, Admin, Manufacturing)
 * land on the page's top.
 */
const SECTION_BY_GROUP: Readonly<Record<string, SectionId>> = {
  sales: 'sales',
  purchases: 'purchases',
  inventory: 'inventory',
  accounting: 'accounting',
  banks: 'accounting',
  partners: 'partners',
  projects: 'projects',
  reports: 'projects',
};

export function helpPathFor(pathname: string): string {
  const group = groupForPath(pathname);
  const section = group === undefined ? undefined : SECTION_BY_GROUP[group.id];
  return section === undefined ? HELP_URL : `${HELP_URL}#${section}`;
}

/** The Contact-us button's target: the page's contact footer. */
export const CONTACT_PATH = `${HELP_URL}#contact`;
